export class EventData {
	name: string;
	value: any;
	constructor(name, value) {
		this.name = name;
		this.value = value;
	}
}